export default {
  // 模块名称
  personMg: {
    // 按钮类
    button: {
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      view: 'View',
      search: 'Query',
      reset: 'Reset',
      cancel: 'Cancel',
      save: 'Save',
      confirm: 'Confirm',
      close: 'Close',
    },
    // 文字标签类
    label: {
      checkAll: 'Check all',
      name: 'Name(press enter auto write)',
      personType: 'Person type',
      phone: 'phone number',
      sex: 'Sex',
      createTime: 'CreateDate',
      startTime: 'Start date',
      endTime: 'End date',
      IDNo: 'ID no',
      upload: 'Upload',
      groups: 'Namegroup',
      nationality: 'Nationality',
      ethnic: 'Ethnic',
      date: 'Birthday',
      job: 'Job',
      remark: 'Remark',
      groupType: 'GroupType',
      groupBlack: 'Black list group',
      whiteBlack: 'White list group',
      avatar: 'Avatar',
      redBlack: 'Red list group',
      groupName: 'GroupName',
    },
    // 提示类
    placeholder: {
      select: 'Select',
      birth: 'Please select birthday',
      filterName: 'Please enter a name to filter',
      choseGroup: 'Please select the list group',
      enter: 'Please enter',
      name: 'Enter name',
      nationality: 'Please enter nationality',
      ethnic: 'Please enter ethnic',
      job: 'Please enter job',
      remark: 'Please enter remark',
      selGender: 'Select gender',
      enterId: 'Enter ID no',
      phone: 'Please enter phoneNumber',
    },
    // 消息类
    message: {
      upload: 'Upload',
      groups: 'Please select list grouping',
      delete: 'Select the list to delete',
      selectDel: 'Delete the selected list. continue?',
      successDel: 'Delete successfully',
      failDel: 'Fail to delete ',
      targetDel: 'Delete the list, do you want to continue?',
      groupDel: 'Delete list group, do you want to continue?',
      noGroups: 'Unselected list group',
      upWarn: 'Maximum upload 1 image',
      formatWarn: 'The picture format is not correct, please choose again',
      sizeWarn: 'The size of the picture should not exceed 4M',
      rightId: 'Please enter the correct id number!',
      rightName: 'Can only be composed of Chinese, English and Numbers',
      groupType: 'Select the list group type',
      groupName: 'Please enter name of person list group',
      blackName: 'Please enter the name of the blacklist group',
      value: "Chinese, letters, Numbers, Spaces are allowed、'·'、'.'、'-'，And the first can not be'·'、'.'、'-'",
    },
    // 标题类
    title: {
      addOk: 'Add successfully',
      editOk: 'Edit successfully',
      add: 'Add list',
      edit: 'Edit list',
      remind: 'Warning',
      addGroup: 'Add group',
      editGroup: 'Edit group',
      detailGroup: 'Group details',
    },
  },
}
